module.exports = __webpack_public_path__ + "static/media/character-sample.2f8ade09.jpg";